import { normalize } from 'normalizr';
import { CreateUserViewModel } from 'stageclip-common';

import { clientsUserSchema, clientsUsersSchema } from './clients.schema';

export const normalizerClientsUsersData = (data: CreateUserViewModel[]) => normalize(data, clientsUsersSchema);
export const normalizerClientUserData = (data: CreateUserViewModel) => normalize(data, clientsUserSchema);
